import type { PageImageTransform, PageRef } from '@/sources/types';

export function pageImageTransformFromRef(ref: PageRef | undefined): PageImageTransform | undefined {
  const transform = ref?.extra?.transform;
  if (!transform || typeof transform !== 'object' || Array.isArray(transform)) return undefined;
  const record = transform as Record<string, unknown>;
  if (record.kind === 'row-reverse' && Number.isInteger(record.rows) && Number(record.rows) > 1) {
    return { kind: 'row-reverse', rows: Number(record.rows) };
  }
  return undefined;
}
